function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { parse } from 'query-string';
import { cleanStorage, getPreviousPath, getRedirectUri, getState } from "./storage";
import { logIn } from "..";
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import uuid from 'uuid/v4';

export var Callback = function Callback(_ref) {
    _objectDestructuringEmpty(_ref);

    var dispatch = useDispatch();
    var history = useHistory();
    var location = useLocation();
    var searchParams = parse(location.search);

    var _useState = useState(false),
        inProgress = _useState[0],
        setInProgress = _useState[1];

    useEffect(function () {
        if (searchParams.code && searchParams.state && !inProgress) {
            setInProgress(true);
            var state = getState();
            if (searchParams.state !== state) {
                console.log('Possible CSRF attack detected!');
                history.push('/');
            } else if (state) {
                codeToToken({
                    code: searchParams.code,
                    history: history,
                    dispatch: dispatch
                });
            }
        }
    }, [searchParams.code, searchParams.state, history, dispatch]);

    return null;
};

var codeToToken = function codeToToken(_ref2) {
    var code = _ref2.code,
        history = _ref2.history,
        dispatch = _ref2.dispatch;

    var redirectUri = getRedirectUri();
    var data = new URLSearchParams();
    data.append('code', code);
    data.append('grant_type', 'authorization_code');
    data.append('redirect_uri', redirectUri);

    fetch(process.env.REACT_APP_API_GATEWAY + '/auths/oauth2/token', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Correlation-Id': uuid()
        },
        credentials: 'include',
        body: data
    }).then(function (response) {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error(response.statusText);
        }
    }).then(function (data) {
        dispatch(logIn(data.access_token, data.expires_in));
        var previousPath = getPreviousPath();
        cleanStorage();
        history.push(previousPath);
    }).catch(function (error) {
        console.log(error);
    });
};